// no baseURI

// object to store loaded and loading chunks
// undefined = chunk not loaded, null = chunk preloaded/prefetched
// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
var installedChunks = {
	7493: 0,
	6199: 0,
	5772: 0,
	6121: 0,
	874: 0,
	2551: 0,
	6016: 0,
	2002: 0,
	5452: 0,
	8694: 0,
	2773: 0,
	5559: 0,
	6550: 0,
	2655: 0,
	3755: 0,
	4545: 0,
	3675: 0,
	6848: 0,
	4119: 0,
	4739: 0,
	8091: 0,
	5022: 0,
	5461: 0,
	2016: 0,
	1321: 0,
	7487: 0,
	268: 0,
	2840: 0,
	263: 0,
	8175: 0,
	7340: 0,
	6757: 0,
	1379: 0,
	5088: 0,
	4934: 0,
	8470: 0,
	9537: 0,
	4460: 0,
	2332: 0,
	3149: 0,
	6436: 0,
	4264: 0,
	4988: 0,
	8730: 0,
	9798: 0,
	8301: 0,
	8431: 0,
	6278: 0,
	729: 0,
	4425: 0,
	4374: 0,
	2584: 0,
	7036: 0,
	3587: 0,
	3687: 0,
	2402: 0,
	9681: 0,
	7111: 0,
	5271: 0,
	7272: 0,
	7931: 0,
	4594: 0,
	4722: 0,
	7014: 0,
	1949: 0,
	9499: 0,
	6334: 0,
	6453: 0,
	5657: 0,
	985: 0,
	514: 0,
	524: 0,
	5949: 0,
	3240: 0
};

// no chunk on demand loading

// no prefetching

// no preloaded

// no HMR

// no HMR manifest

__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);

// install a JSONP callback for chunk loading
var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
	var [chunkIds, moreModules, runtime] = data;
	// add "moreModules" to the modules object,
	// then flag all "chunkIds" as loaded and fire callback
	var moduleId, chunkId, i = 0;
	if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
		for(moduleId in moreModules) {
			if(__webpack_require__.o(moreModules, moduleId)) {
				__webpack_require__.m[moduleId] = moreModules[moduleId];
			}
		}
		if(runtime) var result = runtime(__webpack_require__);
	}
	if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
	for(;i < chunkIds.length; i++) {
		chunkId = chunkIds[i];
		if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
			installedChunks[chunkId][0]();
		}
		installedChunks[chunkId] = 0;
	}
	return __webpack_require__.O(result);
}

var chunkLoadingGlobal = self["webpackChunksouvlaki"] = self["webpackChunksouvlaki"] || [];
chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));